import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'haPatientShareDocPipe'
})
export class HaPatientShareDocPipePipe implements PipeTransform {

  transform(doctorData: any[], searchTermDoctorrr: string): any[]{
    if (!doctorData || !searchTermDoctorrr) { return doctorData; }
    return doctorData.filter(ad =>
     
    
      ad.name.toLowerCase().indexOf(searchTermDoctorrr.toLowerCase().trim()) !== -1
     
  
  
  
  
    );
  }

}
